module.exports = __webpack_public_path__ + "static/media/signup-colorful-bkg.87393029.svg";